/* eslint-disable */
import React, { useEffect, useState } from "react";

interface VisibleRef {
  ref: React.RefObject<Element>;
}

function useIsVisible({ ref }: VisibleRef) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isIntersecting;
}

export default useIsVisible;
